import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Overview from "../containers/Overview";
import Layout from "../layout/Layout";
import Footer from "../components/Footer";
import { fetchHomeOverview } from "../redux/slices/authSlice";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const dispatch = useDispatch();
  const authDetails = useSelector((state) => state.auth.authData);
  const authCodeStatus = useSelector((state) => state.auth.status);
  const membershipChecked = useSelector(
    (state) => state.auth.membershipChecked
  );
  const location = useLocation();

  useEffect(() => {
    const isAuthorized =
      authCodeStatus === "authorized" || authDetails?.status === "authorized";
    const isHomeRoute = location.pathname === "/home";
    if (isAuthorized && membershipChecked && isHomeRoute) {
      dispatch(fetchHomeOverview());
    }
  }, [
    authCodeStatus,
    authDetails,
    membershipChecked,
    location.pathname,
    dispatch,
  ]);

  return (
    <Layout>
      <div className="flex flex-col flex-1 overflow-y-auto h-full dark:text-white">
        <Overview />
        <Footer />
      </div>
    </Layout>
  );
};

export default Dashboard;
